import { colors } from "./../globals/colors";

export const form = {
  skin: {
    base: {
      idle: {
        color: colors.Black,
        placeHolderColor: colors.Black,
        backgroundColor: "#fff",
        borderColor: "rgb(0 0 0 / 20%)",
        iconColor: colors.Black,
      },
      disabled: {
        color: colors.Black,
        placeHolderColor: colors.Black,
        backgroundColor: "#c8c8c8",
        borderColor: "#c8c8c8",
        iconColor: colors.Black,
      },
      active: {
        color: colors.Black,
        placeHolderColor: colors.Primary,
        backgroundColor: "#fff",
        borderColor: "#c2bfbf",
        iconColor: colors.Primary,
      },
      hover: {
        color: colors.Black,
        placeHolderColor: colors.Black,
        backgroundColor: "#fff",
        borderColor: "#c2bfbf",
        iconColor: colors.Black,
      },
      focus: {
        color: colors.Black,
        placeHolderColor: colors.Primary,
        backgroundColor: "#fff",
        borderColor: "#c2bfbf",
        iconColor: colors.Primary,
      },
      error: {
        color: colors.Danger,
        placeHolderColor: colors.Danger,
        backgroundColor: "#fff",
        borderColor: colors.Danger,
        iconColor: colors.Danger,
      },
      readonly: {
        color: colors.Black,
        placeHolderColor: colors.Black25,
        backgroundColor: "#ebebeb",
        borderColor: "transparent",
        iconColor: colors.Black,
      },
    },
  },
  size: {
    md: {
      fontSize: "14px",
      lineHeight: "19px",
      mobileFontSize: "14px",
      mobileLineHeight: "17px",
      height: "36px",
      padding: "10px",
    },
  },
};
